//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-25                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvvtyp) GID:(Web.Set.Des.Ts) V1:(ixs_typ,ixs_tip,aktivita,dat_zmena,zmenu_prov) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_typ */
            public ixs_typ: string;
            /** PK - ixs_tip */
            public ixs_tip: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdeInstitucionalniPredpokladPovolenyTypDokumentuListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesigner>, ixs_typ: string,ixs_tip: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_typ, ixs_tip);
            v_form.addRow("jres:33000145").addField("gselectbox", Gordic.Prefabs.Select.admSrvstip(), { //RC 33000145 : Institucion�ln� p�edpoklad
                dropdown: true,
                name: "ixs_tip",
                model: "model.ixs_tip=value.ixs_tip",
                initialValue: ixs_tip ? { ixs_tip: ixs_tip } : null,
                disabled: ixs_tip ? true : false,
            }) 
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction, {
                hardDefaultFilter: {
                    ixs_typ: ixs_typ,
                    ixs_tip: ixs_tip
                }
            });

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesigner>, ixs_typ: string,ixs_tip: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesigner>, ev, ctx): any {
            var filterObj = {
                ixs_tip: SeznamBase.filterContains(ctx.filter, "ixs_tip")
            }
            that.view = new Gordic.Isl.View(that.isl.AdeInstitucionalniPredpokladPovolenyTypDokumentu.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesignerInit
         * 
         * @param {GContentType<SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesigner>} that
         */
        static SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesignerInit(that: GContentType<SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesigner>, ixs_typ: string,ixs_tip: string ) {
            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, ixs_typ,ixs_tip);
            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);
            this.LoadData(that, ixs_typ, ixs_tip);
        } // SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesignerInit

        static LoadData(that: GContentType<SeznamAdeInstitucionalniPredpokladPovolenyTypDokumentuDesigner>, ixs_typ: string, ixs_tip: string) {
            var filterObj: any = {}
            if (ixs_tip) {
                new Gordic.Data.Readers.AdmSrvstip().getData({ ixs_tip: ixs_tip }).done((o) => {
                    that.filter.findFields("ixs_tip").gfield("setInitial", o[0]);
                })
                filterObj.ixs_tip = ixs_tip;
            }
            that.view = new Gordic.Isl.View(that.isl.AdeInstitucionalniPredpokladPovolenyTypDokumentu.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem
        }
    }
}
